// import React, { useState, useContext } from "react";
// import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
// import Avatar from "@mui/material/Avatar";
// import IconButton from "@mui/material/IconButton";
// import Button from "@mui/material/Button";
// import Info from "@mui/icons-material/Info";
// import Warning from "@mui/icons-material/Warning";
// import Check from "@mui/icons-material/CheckCircle";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import Error from "@mui/icons-material/RemoveCircle";
// import ExitToApp from "@mui/icons-material/ExitToApp";
// import Badge from "@mui/material/Badge";
// import Divider from "@mui/material/Divider";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import ListItemAvatar from "@mui/material/ListItemAvatar";
// import dummy from "dan-api/dummy/dummyContents";
// import messageStyles from "dan-styles/Messages.scss";
// import avatarApi from "dan-api/images/avatars";
// import link from "dan-api/ui/link";
// import { userLogout } from "../../Services/UserUtil";
// import useStyles from "./header-jss";
// import MainContext from "../../Services/Context/MainContext";
// import ApplyInstituteCoordinator from "../../containers/Templates/User/ApplyInstituteCoordinator";
// import ReferralCode from "../../containers/Templates/User/ReferralCode";
// import ResetPassword from "../../containers/Forms/ResetPassword";
// import RequestToInstituteByUser from "../../containers/Templates/User/RequestToInstituteByUser";
// import RewardCard from "../Widget/RewardCard";

// function UserMenu(props) {
//   const { classes, cx } = useStyles();
//   const [menuState, setMenuState] = useState({
//     anchorEl: null,
//     openMenu: null,
//   });

//   const handleMenu = (menu) => (event) => {
//     const { openMenu } = menuState;
//     setMenuState({
//       openMenu: openMenu === menu ? null : menu,
//       anchorEl: event.currentTarget,
//     });
//   };

//   const allContextDetails = useContext(MainContext);
//   const smDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
//   const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
//   const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));

//   const handleClose = () => {
//     setMenuState({ anchorEl: null, openMenu: null });
//   };

//   const handleLogout = () => {
//     const userK_id = allContextDetails?.uid;
//     userLogout(userK_id);
//   };

//   const { dark } = props;
//   const { anchorEl, openMenu } = menuState;
//   return (
//     <div>
//       <IconButton
//         aria-haspopup="true"
//         onClick={handleMenu("notification")}
//         color="inherit"
//         className={cx(classes.notifIcon, dark ? classes.dark : classes.light)}
//         size="large"
//       >
//         <Badge className={classes.badge} badgeContent={4} color="secondary">
//           <i className="ion-ios-notifications-outline" />
//         </Badge>
//       </IconButton>
//       <Menu
//         id="menu-notification"
//         anchorEl={anchorEl}
//         anchorOrigin={{
//           vertical: "top",
//           horizontal: "right",
//         }}
//         transformOrigin={{
//           vertical: "top",
//           horizontal: "right",
//         }}
//         className={classes.notifMenu}
//         PaperProps={{
//           style: {
//             width: 350,
//           },
//         }}
//         open={openMenu === "notification"}
//         onClose={handleClose}
//       >
//         <MenuItem onClick={handleClose}>
//           <div className={messageStyles.messageInfo}>
//             <ListItemAvatar>
//               <Avatar alt="User Name" src={avatarApi[0]} />
//             </ListItemAvatar>
//             <ListItemText
//               primary={dummy.text.subtitle}
//               secondary={dummy.text.date}
//             />
//           </div>
//         </MenuItem>
//         <Divider variant="inset" />
//         <MenuItem onClick={handleClose}>
//           <div className={messageStyles.messageInfo}>
//             <ListItemAvatar>
//               <Avatar className={cx(classes.flex, messageStyles.icon)}>
//                 <Info />
//               </Avatar>
//             </ListItemAvatar>
//             <ListItemText
//               primary={dummy.text.sentences}
//               className={classes.textNotif}
//               secondary={dummy.text.date}
//             />
//           </div>
//         </MenuItem>
//         <Divider variant="inset" />
//         <MenuItem onClick={handleClose}>
//           <div className={messageStyles.messageSuccess}>
//             <ListItemAvatar>
//               <Avatar className={messageStyles.icon}>
//                 <Check />
//               </Avatar>
//             </ListItemAvatar>
//             <ListItemText
//               primary={dummy.text.subtitle}
//               className={classes.textNotif}
//               secondary={dummy.text.date}
//             />
//           </div>
//         </MenuItem>
//         <Divider variant="inset" />
//         <MenuItem onClick={handleClose}>
//           <div className={messageStyles.messageWarning}>
//             <ListItemAvatar>
//               <Avatar className={messageStyles.icon}>
//                 <Warning />
//               </Avatar>
//             </ListItemAvatar>
//             <ListItemText
//               primary={dummy.text.subtitle}
//               className={classes.textNotif}
//               secondary={dummy.text.date}
//             />
//           </div>
//         </MenuItem>
//         <Divider variant="inset" />
//         <MenuItem onClick={handleClose}>
//           <div className={messageStyles.messageError}>
//             <ListItemAvatar>
//               <Avatar className={messageStyles.icon}>
//                 <Error />
//               </Avatar>
//             </ListItemAvatar>
//             <ListItemText
//               primary="Suspendisse pharetra pulvinar sollicitudin. Aenean ut orci eu odio cursus lobortis eget tempus velit. "
//               className={classes.textNotif}
//               secondary="Jan 9, 2016"
//             />
//           </div>
//         </MenuItem>
//         <Divider variant="inset" />
//         <MenuItem onClick={handleClose}>
//           <div className={messageStyles.messageError}>
//             <ListItemAvatar>
//               <Avatar className={messageStyles.icon}>
//                 <Error />
//               </Avatar>
//             </ListItemAvatar>
//             <ListItemText
//               primary="Suspendisse pharetra pulvinar sollicitudin. Aenean ut orci eu odio cursus lobortis eget tempus velit. "
//               className={classes.textNotif}
//               secondary="Jan 9, 2016"
//             />
//           </div>
//         </MenuItem>
//       </Menu>

//       <Button onClick={handleMenu("user-setting")}>
//         {/* <Avatar alt={dummy.user.name} src={dummy.user.avatar} /> */}
//         <img
//           alt={allContextDetails.username}
//           // src={`http://${allContextDetails.pic}`}
//           src={
//             allContextDetails.profile_pic
//               ? `${allContextDetails.profile_pic}`
//               : dummy.user.avatar
//           }
//           className={classes.headerProfile}
//         />
//       </Button>
//       <Menu
//         id="menu-appbar"
//         anchorEl={anchorEl}
//         anchorOrigin={{
//           vertical: "top",
//           horizontal: "right",
//         }}
//         transformOrigin={{
//           vertical: "top",
//           horizontal: "right",
//         }}
//         open={openMenu === "user-setting"}
//         onClose={handleClose}
//       >
//         {/* <MenuItem onClick={handleClose} component={Link} to={link.profile}> */}
//         {/* <MenuItem onClick={handleClose} component={Link} to="/user/userProfile"> */}
//         <MenuItem
//           // onClick={handleClose}
//           component={Link}
//           // to="/administrator/adminProfile"
//           to="/user/dashboard"
//         >
//           My Dashboard
//         </MenuItem>
//         <MenuItem onClick={handleClose} component={Link} to="/user/profiles">
//           My Profile
//         </MenuItem>
//         {/* <MenuItem>
//           <ApplyInstituteCoordinator
//             requestStatus={allContextDetails.status}
//             allInstitutelist={props.allInstituteList}
//             userId={props.userID}
//             remarks={allContextDetails.remarks}
//             isDeletedUser={allContextDetails.is_deleted}
//           />
//         </MenuItem> */}
//         <MenuItem>
//           <RequestToInstituteByUser
//             requestInstituteStatus={allContextDetails.institute_status}
//             instituteNameafterMapped={allContextDetails.institute_name}
//             allInstitutelist={props.allInstituteList}
//             userId={props.userID}
//           />
//         </MenuItem>
//         <MenuItem>
//           <ResetPassword />
//         </MenuItem>
//         <MenuItem>{!mdUp && <RewardCard />}</MenuItem>
//         {/* <MenuItem>
//           <ReferralCode />
//         </MenuItem> */}
//         {/* <MenuItem onClick={handleClose} component={Link} to={link.calendar}>
//           My Calendar
//         </MenuItem>
//         <MenuItem onClick={handleClose} component={Link} to={link.email}>
//           My Inbox
//           <ListItemIcon>
//             <Badge
//               className={cx(classes.badge, classes.badgeMenu)}
//               badgeContent={2}
//               color="secondary"
//             />
//           </ListItemIcon>
//         </MenuItem> */}
//         <Divider />
//         <MenuItem
//           onClick={handleLogout}
//           // component={Link} to="/"
//         >
//           <ListItemIcon>
//             <ExitToApp />
//           </ListItemIcon>
//           Log Out
//         </MenuItem>
//       </Menu>
//     </div>
//   );
// }

// UserMenu.propTypes = {
//   dark: PropTypes.bool,
// };

// UserMenu.defaultProps = {
//   dark: false,
// };

// export default UserMenu;

import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExitToApp from "@mui/icons-material/ExitToApp";
import useMediaQuery from "@mui/material/useMediaQuery";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Loading from "dan-components/Loading";
import dummy from "dan-api/dummy/dummyContents";
import messageStyles from "dan-styles/Messages.scss";
import avatarApi from "dan-api/images/avatars";
import DOMPurify from "dompurify";
import { userLogout } from "../../Services/UserUtil";
import useStyles from "./header-jss";
import MainContext from "../../Services/Context/MainContext";
import Services from "../../Services/Services";
import RequestToInstituteByUser from "../../containers/Templates/User/RequestToInstituteByUser";
import ResetPassword from "../../containers/Forms/ResetPassword";
import RewardCard from "../Widget/RewardCard";

function UserMenu(props) {
  const { classes, cx } = useStyles();
  const [menuState, setMenuState] = useState({
    anchorEl: null,
    openMenu: null,
  });
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedNotification, setExpandedNotification] = useState(false);
  const allContextDetails = useContext(MainContext);
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));

  useEffect(() => {
    const fetchNotifications = async () => {
      if (allContextDetails?.id) {
        try {
          const response = await Services.getEmailNotificationforUser({
            user_id: allContextDetails.id,
          });
          if (response.status === 200) {
            const fetchedNotifications = response.data.data;
            setNotifications([...fetchedNotifications].reverse());
          }
        } catch (err) {
          console.log("Notification fetch error:", err);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchNotifications();
  }, [allContextDetails?.id]);

  const handleMenu = (menu) => (event) => {
    const { openMenu } = menuState;
    setMenuState({
      openMenu: openMenu === menu ? null : menu,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setMenuState({ anchorEl: null, openMenu: null });
  };

  const handleNotificationExpand = (panel) => (event, isExpanded) => {
    setExpandedNotification(isExpanded ? panel : false);
  };

  const handleLogout = () => {
    const userK_id = allContextDetails?.uid;
    userLogout(userK_id);
  };

  const dateFormat = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString();
  };

  const { dark } = props;
  const { anchorEl, openMenu } = menuState;

  return (
    <div>
      {/* <IconButton
        aria-haspopup="true"
        onClick={handleMenu("notification")}
        color="inherit"
        className={cx(classes.notifIcon, dark ? classes.dark : classes.light)}
        size="large"
      >
        <Badge
          className={classes.badge}
          badgeContent={notifications.length}
          color="secondary"
        >
          <i className="ion-ios-notifications-outline" />
        </Badge>
      </IconButton> */}

      <Menu
        id="menu-notification"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        className={classes.notifMenu}
        PaperProps={{
          style: {
            width: 400,
            maxHeight: 500,
          },
        }}
        open={openMenu === "notification"}
        onClose={handleClose}
      >
        {loading ? (
          <MenuItem>
            <div
              style={{ width: "100%", textAlign: "center", padding: "20px" }}
            >
              <Loading />
            </div>
          </MenuItem>
        ) : notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <MenuItem key={index} style={{ padding: 0, width: "100%" }}>
              <Accordion
                expanded={expandedNotification === index}
                onChange={handleNotificationExpand(index)}
                style={{ width: "100%" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`notification-${index}-content`}
                  id={`notification-${index}-header`}
                >
                  <Typography className={classes.heading}>
                    <b>{notification.subject || "..."}</b>
                    <br />
                    <small>
                      From: {notification.sent_by} |{" "}
                      {dateFormat(notification.sent_on)}
                    </small>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {notification.body && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(notification.body),
                        }}
                      />
                    )}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </MenuItem>
          ))
        ) : (
          <MenuItem>
            <Typography>No new notifications</Typography>
          </MenuItem>
        )}
      </Menu>

      <Button onClick={handleMenu("user-setting")}>
        <img
          alt={allContextDetails.username}
          src={
            allContextDetails.profile_pic
              ? `${allContextDetails.profile_pic}`
              : dummy.user.avatar
          }
          className={classes.headerProfile}
        />
      </Button>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={openMenu === "user-setting"}
        onClose={handleClose}
      >
        <MenuItem component={Link} to="/user/dashboard">
          My Dashboard
        </MenuItem>
        <MenuItem onClick={handleClose} component={Link} to="/user/profiles">
          My Profile
        </MenuItem>
        {/* <MenuItem>
          <RequestToInstituteByUser
            requestInstituteStatus={allContextDetails.institute_status}
            instituteNameafterMapped={allContextDetails.institute_name}
            allInstitutelist={props.allInstituteList}
            userId={props.userID}
          />
        </MenuItem> */}
        <MenuItem>
          <ResetPassword />
        </MenuItem>
        <MenuItem>{!mdUp && <RewardCard />}</MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          Log Out
        </MenuItem>
      </Menu>
    </div>
  );
}

UserMenu.propTypes = {
  dark: PropTypes.bool,
};

UserMenu.defaultProps = {
  dark: false,
};

export default UserMenu;
